export default {
  data: () => ({
    success: false,
    errors: []
  }),

  methods: {
    hasError (key) {
      let error = this.errors.find(el => el.field === key);

      if (error) return error.message;

      return '';
    }
  }
};